





























































































































































import * as R from 'ramda';
import Vue from 'vue';
import moment from 'moment';
import { getDepartment, GqlDepartment, getJob, GqlJob } from './graphql';

interface Option {
  label: string;
  value: string;
}

export default Vue.extend({
  apollo: {
    departments: {
      query: getDepartment,
      variables: {
        level: 3,
      },
    },
  },

  data() {
    const form = this.$form.createForm(this, {
      // @ts-ignore handlePriorityChanged is in methods
      onValuesChange: this.handlePriorityChanged,
    });
    const format = 'YYYY-MM-DD';
    return {
      job: null as GqlJob[] | null,
      departments: null as GqlDepartment[] | null,
      form,
      isPriority: false,
      defaultDate: moment(moment().format(format), format),
      date: moment().format(format),
      selectedJobIds: [] as string[],
      selectedOutletIds: [] as string[],
      jobIds: [] as string[],
      outletIds: [] as string[],
    };
  },

  mounted() {
    this.loadData();
  },

  computed: {
    options(): Option[] {
      if (this.departments === null) {
        return [];
      }

      return R.pipe(
        R.sortWith([R.ascend<GqlDepartment>(R.prop('name'))]),
        R.map<GqlDepartment, Option>((d) => ({
          label: d.name,
          value: d.id,
        })),
      )(this.departments!);
    },

    jobOptions(): Option[] {
      if (this.job === null) {
        return [];
      }

      // Filter out only selected jobs
      const jobs = R.map((job) => {
        return R.filter((jobId) => jobId === job.id, this.selectedJobIds);
      }, this.job);

      const selectedJobs: any = R.flatten(jobs);
      this.jobIds = selectedJobs;
      const jobIds: string[] = [];
      for (const job of this.job) {
        // @ts-ignore
        if (selectedJobs.includes(job.id)) {
          jobIds.push(job.id);
        }
      }

      this.$nextTick(() => {
        this.form.setFieldsValue({
          jobs: jobIds,
        });
      });

      return R.pipe(
        R.sortWith([R.ascend<GqlJob>(R.prop('description'))]),
        R.map<GqlJob, Option>((d) => ({
          label: d.description,
          value: d.id,
        })),
      )(this.job!);
    },

    outletOptions(): Option[] {
      if (this.job === null) {
        return [];
      }

      const jobs = R.map((job) => {
        return R.filter((jobId) => jobId === job.id, this.selectedJobIds);
      }, this.job);
      const selectedJobs = R.flatten(jobs);

      const options: Option[] = [];
      const outletIds: string[] = [];

      for (const job of this.job) {
        // @ts-ignore
        if (!selectedJobs.includes(job.id)) {
          continue;
        }
        for (const outlet of job.outlets) {
          options.push({
            label: outlet.name,
            value: outlet.id,
          });

          outletIds.push(outlet.id);
        }
      }

      this.$nextTick(() => {
        this.form.setFieldsValue({
          outlets: outletIds,
        });
      });
      this.outletIds = outletIds;
      return options;
    },
  },

  methods: {
    async loadData() {
      const result = await this.$apollo.query({
        query: getJob,
        variables: {
          date: this.date,
        },
      });
      this.job = result.data.job;
      // @ts-ignore
      this.selectedJobIds = R.pluck('id', this.job);
      this.selectedOutletIds = R.flatten(R.map((job: any) => {
        // @ts-ignore
        return R.pluck('id', job.outlets);
      }, this.job as any));
    },

    handlePriorityChanged(props: any, values: { [key: string]: any }) {
      if (values.priority !== undefined) {
        this.isPriority = values.priority || false;
      }
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], val: any) => {
        if (errors === null) {
          const date = val.date.format('YYYY-MM-DD');
          // either it is high priority or category will be provided
          const category = val.category || 'high-priority';
          this.$router.push({
            name: 'review.entry.list',
            params: {
              date,
              category,
              filter: {
                jobIds: this.selectedJobIds,
                outletIds: this.selectedOutletIds,
              } as any,
            },
          });
        }
      });
    },

    updateDate(value: string) {
      this.date = moment(value).format('YYYY-MM-DD');
      this.loadData();
    },

    handleJobChange(value: string[]) {
      // @ts-ignore
      this.selectedJobIds = value;
    },
    handleOutletChange(value: string[]) {
      // @ts-ignore
      this.selectedOutletIds = value;
    }
  },
});
